import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from '@boxx/shared-components';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { ContactPickerModalComponent } from './contact-picker-modal/contact-picker.modal';
import { ContactPickerTypeModalComponent } from './contact-picker-type-modal/contact-picker-type-modal';
import { ContactSinglePickerModalComponent } from './contact-single-picker-modal/contact-single-picker.modal';

@NgModule({
  declarations: [
    ContactPickerModalComponent,
    ContactSinglePickerModalComponent,
    ContactPickerTypeModalComponent,
    ContactFormComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    SharedComponentsModule,
    NgxPermissionsModule.forChild(),
  ],
  exports: [
    ContactPickerModalComponent,
    ContactSinglePickerModalComponent,
    ContactPickerTypeModalComponent,
    ContactFormComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class ContactsCoreComponentsModule {}
